export default {
  'INEP' (state) {
    return state.inep
  },
  'INEPS' (state) {
    return state.ineps
  }
}
